@if(title){
<div class="div-parent">
  <div class="div-title">
    {{ title }}
  </div>
  <div class="right-panel-close-button">
    @if (showBlueprintNavigation) {
    <button pButton type="button" class="toolbar-icon p-button-text" icon="pi pi-chevron-up" [pTooltip]="navPreviousTooltip" tooltipPosition="left" (click)="onNavigate(navPrevious)"></button>
    <button pButton type="button" class="toolbar-icon p-button-text" icon="pi pi-chevron-down" [pTooltip]="navNextTooltip" tooltipPosition="left" (click)="onNavigate(navNext)"></button>
    }
    <button pButton type="button" class="toolbar-icon p-button-rounded p-button-text" icon="pi pi-times" pTooltip="Close panel" tooltipPosition="left" (click)="onCloseShortRightPanel()"></button>
  </div>
</div>
}
